import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { knowledgeBase } from "./content";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("root element is missing");

createRoot(root).render(
  <StrictMode>
    <App knowledgeBase={knowledgeBase} />
  </StrictMode>,
);

